import { render } from "./DialogueMenu.vue?vue&type=template&id=0428e694&scoped=true"
import script from "./DialogueMenu.vue?vue&type=script&lang=js"
export * from "./DialogueMenu.vue?vue&type=script&lang=js"

import "./DialogueMenu.vue?vue&type=style&index=0&id=0428e694&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0428e694"]])

export default __exports__